import { t } from '@lingui/core/macro';
import { DateRangeFilter } from './DateFilter';
export const noticeDateFilterLabel = () => t({
    message: 'Notice date',
    comment: 'Insights: Date signed date filter',
});
export function NoticeDateFilter() {
    return <DateRangeFilter name="metadataDocumentNoticeDate" label={noticeDateFilterLabel()}/>;
}
